/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsMoveHorizontal = createReactComponent("outline", "arrows-move-horizontal", "IconArrowsMoveHorizontal", [["path", { "d": "M18 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M15 12h6", "key": "svg-1" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-2" }], ["path", { "d": "M3 12h6", "key": "svg-3" }]]);

export { IconArrowsMoveHorizontal as default };
//# sourceMappingURL=IconArrowsMoveHorizontal.mjs.map
